import { defineMessages } from 'react-intl-next';

export const messages: {
    errorLoadingCardsPreamble: {
        defaultMessage: string;
        description: string;
        id: string;
    }; errorLoadingCardsSupport: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	errorLoadingCardsPreamble: {
		id: 'company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-preamble',
		defaultMessage: 'We’re having trouble loading these cards.',
		description:
			'Footer message shown when there was an error fetching search results for dynamic cards.',
	},
	errorLoadingCardsSupport: {
		id: 'company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-support',
		defaultMessage: 'Reload to try again.',
		description:
			'Footer message shown when there was an error fetching search results for dynamic cards.',
	},
});
